import React from 'react';
import { useSelector } from 'react-redux';
import ClientServiceList from './components/ClientServiceList';

const MyServices = () => {
	const currentUser = useSelector((st) => st.user.currentUser);

	if (!currentUser) {
		return (
			<div className='min-h-screen bg-gray-50 flex items-center justify-center'>
				<div className='text-center'>
					<h2 className='text-2xl font-glacial font-semibold text-gray-900 mb-4'>
						Please log in to access your services
					</h2>
					<p className='text-gray-600 font-montserrat-regular'>
						You need to be logged in to view and manage your subscriptions.
					</p>
				</div>
			</div>
		);
	}

	return <ClientServiceList />;
};

export default MyServices;